import { Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import {
    deletemsg,
    deleteWarningMsg,
    noInternetMsg,
    serverMsg
} from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { ReplicaTransactionJson } from "../../DynamicFormsJson/MastersJSON/replicaTransaction";
import { apiGet } from "../../utils/api_service";
import endpoint from "../../config/endpoints";
import swal from "sweetalert";

class ReplicaTransaction extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {

            },

        };
    }
    async componentDidMount() {

    }



    onDeleteData = async (rowData) => {
        const { showLoador, showNotification } = this.props;

        if (navigator.onLine) {

            showLoador({ loador: true });
            await apiGet({
                url:
                    endpoint.outletOrderHeaderReplica + "/count-by-dates?fromDate="
                    + rowData.fromDate + "&toDate=" + rowData.toDate,
            }).then(({ data, success }) => {
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                } else {
                    let count = data?.data?.count ?? 0;
                    swal({
                        title: "Are you sure?",
                        text: "This record has " + "" + count
                            + "" + " counts. " + deleteWarningMsg,
                        icon: "warning",
                        buttons: true,
                        dangerMode: true,
                    }).then(async (willDelete) => {
                        if (willDelete) {

                            showLoador({ loador: true });
                            await apiGet({
                                url:
                                    endpoint.outletOrderHeaderReplica + "/delete-by-dates?fromDate="
                                    + rowData.fromDate + "&toDate=" + rowData.toDate,
                            }).then(({ data, success }) => {
                                showLoador({ loador: false });
                                if (!success) {
                                    showNotification({ msg: serverMsg, severity: "error" });
                                } else {
                                    showNotification({ msg: deletemsg, severity: "success" });
                                }
                            });
                        }
                    });
                }
            });



        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    render() {
        const { dynamicMasterData } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 2,
                    }}
                    elevation={0}
                >
                    <DynamicFormWithoutSave
                        showBackToList={false}
                        dynamicMasterData={dynamicMasterData}
                        showTitle={true}
                        screenTitle={ReplicaTransactionJson.screenTitle}
                        fieldMeta={ReplicaTransactionJson.fieldMeta}
                        showSaveBtnMain={false}
                        showSaveNextBtn={false}
                        showSaveBtn={true}
                        saveBtnText={"Delete"}
                        onSave={this.onDeleteData}
                        padding={true}
                        paddingTop={true}
                    />
                </Paper>
            </>
        );
    }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = { showNotification, showLoador };
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ReplicaTransaction);

